import Polyline from '@arcgis/core/geometry/Polyline';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import { WGS84_SPATIAL_REFERENCE } from './spatialReference';
import type { UscgSymbol } from './uscgSymbology';
import { PointGeometry } from './constants';

export const BOOM_STYLING = {
  LINE_WIDTH: 2,
  LINE_COLOR: '#000000',
  LINE_OPACITY: 0.8,
  POINT_SIZE: 6,
  POINT_COLOR: [0, 0, 0, 0.8],
  // Graphics layer renders differently (I guess?), and needs a thinner line to match
  GRAPHICS_LINE_WIDTH: 1.5,
  TRANSPARENT_LINE_OPACITY: 0,
  HIT_AREA_LINE_WIDTH: 8,
  HIT_AREA_POINT_SIZE: 16,
  HIT_AREA_COLOR: [0, 0, 0, 0],
} as const;

export const OIL_SPILL_STYLING = {
  LINE_WIDTH: 3,
  LINE_COLOR: '#FF0000',
  LINE_OPACITY: 0.8,
  // Graphics layer renders differently, so we need a thinner line to match
  GRAPHICS_LINE_WIDTH: 2,
} as const;

export function createPolylineFromPoints(points: PointGeometry[]): Polyline {
  const paths = points.map((p) => [p.longitude, p.latitude]);
  return new Polyline({
    paths: [paths],
    spatialReference: WGS84_SPATIAL_REFERENCE,
  });
}

export function createPolylineSymbol(symbolKey: UscgSymbol): SimpleLineSymbol {
  if (symbolKey === 'oilSpill') {
    return new SimpleLineSymbol({
      color: OIL_SPILL_STYLING.LINE_COLOR,
      width: OIL_SPILL_STYLING.GRAPHICS_LINE_WIDTH,
    });
  }
  if (symbolKey === 'proposedBoom' || symbolKey === 'completedBoom') {
    return new SimpleLineSymbol({
      color: BOOM_STYLING.LINE_COLOR,
      width: BOOM_STYLING.GRAPHICS_LINE_WIDTH,
    });
  }

  if (symbolKey === 'customLine') {
    return new SimpleLineSymbol({
      color: '#1d4ed8',
      width: 2,
    });
  }

  return new SimpleLineSymbol({
    color: '#0f766e',
    width: 2,
  });
}
